// extracted by mini-css-extract-plugin
export default {"card":"card__y-u8G","vendor":"vendor__M2+fE","date":"date__h7F8f","certificate":"certificate__3DglR"};